

export enum ResourceMetadataKey {

    DataProcessing = "data_processing",
    DataCleaning = "data_cleaning_rules",
    PostProcessing = "post_processing",
    AdvancedAnalysis = 'advanced_analysis'
}